var map = {
	"./(Old)Our-Team-KruNote.jpg": "a296",
	"./Acharya_Satyapati.jpg": "b698",
	"./Anand_Singh.jpg": "d069",
	"./Ananya.jpg": "8e5e",
	"./Anna.jpg": "38f0",
	"./Dimitris_Cyprus.jpeg": "e8ef",
	"./Dr_Ishwar_Bharadwaj.jpg": "a22a",
	"./Guru_Dharm-v1.png": "4232",
	"./Guru_Dharm.jpg": "cfa1",
	"./Kru_Jom.jpg": "a87f",
	"./Kru_Note.jpg": "4296",
	"./Kru_Oh.jpg": "4a16",
	"./Luigi_Italy.jpeg": "90e7",
	"./Madelyn_Cecily_Ryan.jpeg": "992ea",
	"./Monika.jpg": "52b6",
	"./Panji.jpg": "283a",
	"./RabihElMdawar-v1.png": "c93b",
	"./Sajjan_Kaur.jpeg": "2249",
	"./Saruda-v1.png": "0b57",
	"./Shivani.jpg": "66dc",
	"./Sirichon-v1.png": "4978"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86bf";